var _path, _path2, _rect, _path3, _rect2, _path4, _circle, _path5, _path6, _rect3, _path7, _rect4, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.13 41h23.87v4h-23.87z",
    fill: "#556080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3 18h44v4h-44z",
    fill: "#556080"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#8697cb",
    height: 50,
    rx: 2,
    width: 4,
    x: 1,
    y: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45 27.13v-24.13a2.006 2.006 0 0 1 2-2 1.955 1.955 0 0 1 1.41.59 1.955 1.955 0 0 1 .59 1.41v25.17z",
    fill: "#8697cb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f29c1f",
    height: 14,
    rx: 2,
    width: 14,
    x: 9,
    y: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.678 10.856-1.678-1.119-1.678 1.119a.851.851 0 0 1 -1.322-.708v-6.148h6v6.148a.851.851 0 0 1 -1.322.708z",
    fill: "#d25627"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    fill: "#3b97d3",
    r: 16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m55.707 41.293a1 1 0 0 0 -1.414 0l-.381.381a11 11 0 0 0 -20.44-4.174 1 1 0 0 0 1.732 1 9 9 0 0 1 16.652 2.941l-.149-.149a1 1 0 0 0 -1.414 1.414l2 2a1 1 0 0 0 1.414 0l2-2a1 1 0 0 0 0-1.413z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m52.163 47.135a1 1 0 0 0 -1.363.365 9 9 0 0 1 -16.652-2.941l.149.149a1 1 0 0 0 1.414-1.414l-2-2a1 1 0 0 0 -1.414 0l-2 2a1 1 0 0 0 1.414 1.414l.381-.381a11 11 0 0 0 20.436 4.173 1 1 0 0 0 -.365-1.365z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f29c1f",
    height: 14,
    rx: 2,
    width: 14,
    x: 27,
    y: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m35.678 10.856-1.678-1.119-1.678 1.119a.851.851 0 0 1 -1.322-.708v-6.148h6v6.148a.851.851 0 0 1 -1.322.708z",
    fill: "#d25627"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f29c1f",
    height: 14,
    rx: 2,
    width: 14,
    x: 9,
    y: 27
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m17.678 33.856-1.678-1.119-1.678 1.119a.851.851 0 0 1 -1.322-.708v-6.148h6v6.148a.851.851 0 0 1 -1.322.708z",
    fill: "#d25627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestocked);
export default __webpack_public_path__ + "static/media/restocked.f08ae543dc96e7893196e15ac9e38521.svg";
export { ForwardRef as ReactComponent };